<span class="mits-badge" #mitsBadgeSpan>
  <span class="mits-badge-title" *ngIf="title">{{title}}</span>
  {{ value }}
</span>